<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 에너지 실적 자료 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 에너지 실적 자료</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>제목</div>
          <p v-if="isPrint" class="print-input">{{ form.제목 }}</p>
          <ml-input v-else class="w-full" v-model="form.제목" visible-counter :max="100" />
        </div>
        <div class="writeGridLineItem">
          <div>내용</div>
          <p v-if="isPrint" class="print-input">{{ form.내용 }}</p>
          <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.내용" :max="1000" :readonly="board.readonly"/>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  components: {
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},

        제목: '',
        내용: '',
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
